// src/Utils/Rules/FieldDependencyRules.js
export const FieldDependencyRules = [
  {
    form: "additionalInfo", // your form name (can be dynamic)
    target: "exportAdditionalinfoQualifier", // field to update
    dependsOn: ["exportAdditionalinfoType"], // field to watch
    formula: ({ exportAdditionalinfoType }) => {
      const optionsMap = {
        "Item Characteristics": [
          { label: "Breed", value: "breed" },
          { label: "Colour", value: "colour" },
          { label: "GST Allowed", value: "gstAllowed" },
          { label: "Plant Variety", value: "plantVariety" },
          { label: "Sex", value: "sex" },
          { label: "Storage Condition", value: "storageCondition" },
        ],
        "Item Category": [
          { label: "Drug Related Category", value: "drugRelatedCategory" },
          {
            label: "Foods & Supplement Propriety Status",
            value: "foodsupplementproperty",
          },
          { label: "Grade of the Product", value: "gradeofproduct" },
          { label: "Indian Food Code", value: "indianFoodCode" },
          { label: "Lab Grown Diamond", value: "labcoursecleared" },
          { label: "Plant Category", value: "plantCategory" },
          { label: "Plant parts", value: "plantParts" },
        ],
        "Hand Carry": [
          {
            label: "E-Ticket/Ticket Number",
            value: "eticketnumber",
          },
          {
            label: "Passport Number",
            value: "passportnumber",
          },
          { label: "PNR Number", value: "pnrnumbeScientificNamer" },
        ],
        "Item Identification": [
          {
            label: "Animal Passport Number",
            value: "animalpassportnumber",
          },
          {
            label: "Chemical Abstract Service Registration Number",
            value: "chemicalabstrack",
          },
          {
            label: "Electronic Componet Identification Number",
            value: "ElectronicComponet",
          },
          {
            label: "Global Trade Item Number",
            value: "Global Trade Item Number",
          },
          {
            label:
              "Microchips Numbers Inserted Into Animal For Identification Purposes ",
            value: "MicrochipsNumbersInsertedInto",
          },
          {
            label: "Vehicle Identification Number",
            value: "VehicleIdentificationNumber",
          },
        ],
        "Origin Criteria": [
          {
            label: "Product Specific Rules",
            value: "productSpecificRules",
          },
          {
            label: "Value Added",
            value: "valueAdded",
          },
          {
            label: "Wholly Obtained or Producted",
            value: "WhollyObtainedProducted",
          },
        ],
        "PGA Exception category": [
          {
            label: "DG0012016",
            value: "PQAException_DCO2016",
          },
          {
            label: "PQ0012016",
            value: "PQAException_PROD2016",
          },
        ],
        "Product Name": [
          {
            label: "Common Name",
            value: "commonName",
          },
          {
            label: "International Non Proprietary Name",
            value: "InternationalNonProprietaryName",
          },
          {
            label: "Name as Contained in a Pharmacopeia",
            value: "NameasContainedinaPharmacopeia",
          },
          {
            label: "Name as Per the IUPAC Nomenclature",
            value: "NamePertheIUPACNomenclature",
          },
          {
            label: "Name of the LiveStock Product",
            value: "NameoftheLiveStockProduct",
          },
          {
            label: "Name of the Model",
            value: "NameoftheModel",
          },
          {
            label: "Pet Name",
            value: "petname",
          },
          {
            label: "Plant Commodity Name",
            value: "PlantCommodityName",
          },
          {
            label: "Scientific Name",
            value: "ScientificName",
          },
          {
            label: "Trade or Commercial Name",
            value: "TradeorCommercialName",
          },
        ],
      };

      const result = optionsMap[exportAdditionalinfoType] || [];

      return result;
    },
  },
  {
    form: "productiondetails", // your form name
    target: "importProductBestBeforeDate", // field to disable/enable
    dependsOn: ["importProductExpiryDate"], // watch expiryDate changes
    formula: ({ importProductExpiryDate }) => {
      if (!importProductExpiryDate) {
        // if expiryDate not selected, keep it enabled (user can still fill)
        return { disabled: false };
      }

      const expiry = new Date(importProductExpiryDate);
      const today = new Date();

      const isExpired = today > expiry;

      return {
        disabled: isExpired, // disable when expired
        maxDate: expiry, // limit selection to expiry date
      };
    },
  },
  {
    form: "productiondetails", // your form name
    target: "importProductBestBeforeDate", // field to disable/enable
    dependsOn: ["importProductManufacuturerDate"], // watch expiryDate changes
    formula: ({ importProductManufacuturerDate }) => {
      if (!importProductManufacuturerDate) {
        return { disabled: false };
      }

      const start = new Date(importProductManufacuturerDate);
      const today = new Date();

      return {
        // disabled: isExpired, // disable when expired
        minDate: start, // limit selection to expiry date
      };
    },
  },
  {
    form: "productionDetails",
    target: "exportProductBestBeforeDate",
    dependsOn: ["exportProductManufacuturerDate"],
    formula: ({ exportProductManufacuturerDate }) => {
      if (!exportProductManufacuturerDate) {
        return { disabled: false };
      }

      const start = new Date(exportProductManufacuturerDate);

      return {
        // disabled: isExpired, // disable when expired
        minDate: start, // limit selection to expiry date
      };
    },
  },
  {
    form: "productiondetails", // your form name
    target: "exportProductBestBeforeDate", // field to disable/enable
    dependsOn: ["exportProductExpiryDate"], // watch expiryDate changes
    formula: ({ exportProductExpiryDate }) => {
      if (!exportProductExpiryDate) {
        // if expiryDate not selected, keep it enabled (user can still fill)
        return { disabled: false };
      }

      const expiry = new Date(exportProductExpiryDate);
      const today = new Date();

      const isExpired = today > expiry;

      return {
        disabled: isExpired, // disable when expired
        maxDate: expiry, // limit selection to expiry date
      };
    },
  },
  {
    form: "exportProduct",
    target: "declarationCode",
    dependsOn: "declarationType",
    formula: ({ declarationType }) => {
      const optionsMap = {
        Declaration: [
          {
            label: "DB001-DBK Declaration - No IGST ITC availed",
            value: "DB001-DBK Declaration - No IGST ITC availed",
          },
          {
            label: "DB002-DBK Declaration - No IGST Refund claimed",
            value: "DB002-DBK Declaration - No IGST Refund claimed",
          },
          {
            label: "DB003-DBK Declaration - No CENVAT credit carry forward",
            value: "DB003-DBK Declaration - No CENVAT credit carry forward",
          },
          {
            label: "RD001 - RODTEP Declaration",
            value: "RD001 - RODTEP Declaration",
          },
          {
            label: "R5001 - ROSCTL Declaration",
            value: "R5001 - ROSCTL Declaration",
          },
        ],
      };

      const result = optionsMap[declarationType] || [];

      return result;
    },
  },
  {
    form: "importInvoice",
    target: "declarationCode",
    dependsOn: "importInvoiceDeclarationType",
    formula: ({ importInvoiceDeclarationType }) => {
      const optionsMap = {
        Declaration: [
          {
            label: "CUV01 - Valuation Declaration - I",
            value: "CUV01 - Valuation Declaration - I",
          },
          {
            label: "CUV02 - Valuation Declaration - II",
            value: "CUV02 - Valuation Declaration - II",
          },
          {
            label: "CUV03 - Valuation Declaration - III",
            value: "CUV03 - Valuation Declaration - III",
          },
          {
            label: "CUV04 - Related Party Declaration",
            value: "CUV04 - Related Party Declaration",
          },
          {
            label: "CUV05 - Related Party Declaration",
            value: "CUV05 - Related Party Declaration",
          },
        ],
      };

      const result = optionsMap[importInvoiceDeclarationType] || [];

      return result;
    },
  },
  // {
  //   form : "exportProductSingleWindow",
  //   target : "exportAdditionalinfoCode",
  //   dependsOn : ["exportAdditionalinfoQualifier"],
  //   property : "setQueryParams",
  //   formula : ({exportAdditionalinfoQualifier}) => {
  //    return {
  //      queryParams : {
  //       type : exportAdditionalinfoQualifier
  //      }
  //    }
  //   },
  // }
  {
    form: "additionalInfo", // your form name (can be dynamic)
    target: "importAdditionalinfoQualifier", // field to update
    dependsOn: ["importAdditionalinfoType"], // field to watch
    formula: ({ importAdditionalinfoType }) => {
      const optionsMap = {
        "Item Characteristics": [
          { label: "Breed", value: "breed" },
          { label: "Colour", value: "colour" },
          { label: "GST Allowed", value: "gstAllowed" },
          { label: "Plant Variety", value: "plantVariety" },
          { label: "Sex", value: "sex" },
          { label: "Storage Condition", value: "storageCondition" },
          { label: "Storage Temp", value: "storageTemp" },
        ],
        "Item Category": [
          { label: "Drug Related Category", value: "drugRelatedCategory" },
          {
            label: "Foods & Supplement Propriety Status",
            value: "foodsupplementproperty",
          },
          { label: "Grade of the Product", value: "gradeofproduct" },
          { label: "Indian Food Code", value: "indianFoodCode" },
          { label: "Lab Course Cleared", value: "Labcoursecleared" },
          { label: "Plant Category", value: "plantCategory" },
          { label: "Plant parts", value: "plantParts" },
        ],
        "Hand Carry": [
          {
            label: "E-Ticket/Ticket Number",
            value: "eticketnumber",
          },
          {
            label: "Passport Number",
            value: "passportnumber",
          },
          { label: "PNR Number", value: "pnrnumbeScientificNamer" },
        ],
        "Item Identification": [
          {
            label: "Animal Passport Number",
            value: "animalpassportnumber",
          },
          {
            label: "Chemical Abstract Service Registration Number",
            value: "chemicalabstrack",
          },
          {
            label: "Electronic Componet Identification Number",
            value: "ElectronicComponet",
          },
          {
            label: "Global Trade Item Number",
            value: "Global Trade Item Number",
          },
          {
            label: "Microchip No (for animals)",
            value: "MicrochipsNumbersInsertedInto",
          },
          {
            label: "Vehicle Identification Number",
            value: "VehicleIdentificationNumber",
          },
        ],
        "Origin Criteria": [
          {
            label: "Product Specific Rules",
            value: "productSpecificRules",
          },
          {
            label: "Value Added",
            value: "valueAdded",
          },
          {
            label: "Wholly Obtained or Producted",
            value: "WhollyObtainedProducted",
          },
        ],
        "PGA Exception category": [
          {
            label: "DG0012016",
            value: "PQAException_DCO2016",
          },
          {
            label: "PQ0012016",
            value: "PQAException_PROD2016",
          },
        ],
        "Product Name": [
          {
            label: "Common Name",
            value: "commonName",
          },
          {
            label: "International Non Proprietary Name",
            value: "InternationalNonProprietaryName",
          },
          {
            label: "Name as Contained in a Pharmacopeia",
            value: "NameasContainedinaPharmacopeia",
          },
          {
            label: "Name as Per the IUPAC Nomenclature",
            value: "NamePertheIUPACNomenclature",
          },
          {
            label: "Name of the LiveStock Product",
            value: "NameoftheLiveStockProduct",
          },
          {
            label: "Name of the Model",
            value: "NameoftheModel",
          },
          {
            label: "Pet Name",
            value: "petname",
          },
          {
            label: "Plant Commodity Name",
            value: "PlantCommodityName",
          },
          {
            label: "Scientific Name",
            value: "ScientificName",
          },
          {
            label: "Trade or Commercial Name",
            value: "TradeorCommercialName",
          },
        ],
      };

      const result = optionsMap[importAdditionalinfoType] || [];

      return result;
    },
  },
];
